import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirmar Endereço de E-mail',
  [OnboardingStep.BusinessInfo]: 'Adicione os dados da sua loja',
  [OnboardingStep.PersonalInfo]: 'Adicione as suas informações pessoais',
  [OnboardingStep.ShippingInfo]: 'Adicione as suas informações de entrega',
  [OnboardingStep.BankInfo]: 'Adicione dados bancários para pagamentos',
  [OnboardingStep.TaxInfo]: 'A sua empresa está registada para IVA?',
  [OnboardingStep.BusinessDocs]: 'Documento comprovativo de empresa',
  [OnboardingStep.PersonalDocs]: 'Documento comprovativo de identidade',
  [OnboardingStep.InfoSubmission]: 'Receber pagamentos',
  confirm_info_gateway: 'Receber pagamentos – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informações de pagamento',
  [OnboardingStep.Subscription]: 'Subscrição',
  [OnboardingStep.MobileApp]: 'Aplicação móvel',
  [OnboardingStep.DeliveryStructure]: 'Estrutura de entrega',
  [OnboardingStep.Contract]: 'Contrato',
  [OnboardingStep.ContractPayment]: 'Pagamento do contrato',
  [OnboardingStep.PromoCode]: 'Código promocional',
};
